import { Injectable } from '@angular/core';
import { BaseService } from '../abstracts/base.service';
import { ResultModel } from '../models/result.model';
import { SubjectModel } from '../models/subject.model';
import { TimeTableModel } from '../models/time-table.model';

@Injectable({
  providedIn: 'root'
})
export class TimeTableService extends BaseService {

  create(data: TimeTableModel) {
    return this.httpClient.post<ResultModel>(this.getApiUrl('time-table'), data);
  }

  update(data: TimeTableModel) {
    return this.httpClient.put(this.getApiUrl('time-table'), data);
  }

  getByID(id: string) {
    return this.httpClient.get<ResultModel<TimeTableModel>>(this.getApiUrl('time-table/' + id));
  }

  getByClassID(id: string) {
    return this.httpClient.get<ResultModel<TimeTableModel[]>>(this.getApiUrl('time-table/class/' + id));
  }

  getByInstructorID(id: string) {
    return this.httpClient.get<ResultModel<TimeTableModel[]>>(this.getApiUrl('time-table/instructor/' + id));
  }

  delete(id: string) {
    return this.httpClient.delete<ResultModel>(this.getApiUrl('time-table/' + id));
  }


}
